import { render, staticRenderFns } from "./otherTables.vue?vue&type=template&id=5086b5ac&scoped=true"
import script from "./otherTables.vue?vue&type=script&lang=js"
export * from "./otherTables.vue?vue&type=script&lang=js"
import style0 from "./otherTables.vue?vue&type=style&index=0&id=5086b5ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5086b5ac",
  null
  
)

export default component.exports